import { Grid } from '@mui/material'
import styles from './signup.module.scss'

// import GoogleIcon from '@mui/icons-material/Google'
import ForgotPwForm from './ForgotPwForm.jsx'
import AuthCommonCard from '../molecules/AuthCommonCard.jsx'
import AuthCommonForm from '../molecules/AuthCommonForm.jsx'

const ForgotPwComp = () => {
	return (
		// <section className={styles.forgotPwSection}>
		// 	<div className="container">
		// 		<div className={styles.inner}>
		// 			<Grid container alignItems={'unset'}>
		// 				<Grid size={{ xs: 12, sm: 6 }}>
		// 					<div className={styles.imageContainer}>
		// 						<img
		// 							src="/images/signup-img.png"
		// 							alt="signup-img.jpg"
		// 						/>
		// 					</div>
		// 				</Grid>
		// 				<ForgotPwForm />
		// 			</Grid>
		// 			<div className={styles.bgImg}>
		// 				<img src="/images/clock-img.png" alt="clock-img.png" />
		// 			</div>
		// 		</div>
		// 	</div>
		// </section>
		<AuthCommonCard className={styles.ForgotPwSection}>
			<AuthCommonForm
				title={'Forgot Password?'}
				subTitle={
					<>
						Enter your email address and we'll send you a link to
						reset your password
					</>
				}
			>
				<ForgotPwForm />
			</AuthCommonForm>
		</AuthCommonCard>
	)
}

export default ForgotPwComp
